// extracted by mini-css-extract-plugin
module.exports = {"upload-wrapper":"upload-wrapper--1ekI3DHP","uploader-tooltip":"uploader-tooltip--1P79H5Ix"};